export const formatDate = (dateString: string): string => {
  // Crear la fecha especificando que es en zona horaria local
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day); // month - 1 porque los meses van de 0-11
  
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  
  const isToday = date.toDateString() === today.toDateString();
  const isTomorrow = date.toDateString() === tomorrow.toDateString();
  
  const options: Intl.DateTimeFormatOptions = { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  };
  
  const formattedDate = date.toLocaleDateString('es-ES', options);
  
  if (isToday) {
    return `Hoy, ${formattedDate}`;
  } else if (isTomorrow) {
    return `Mañana, ${formattedDate}`;
  } else {
    return formattedDate;
  }
};

// Función para formatear fecha en formato DD-MM-YYYY
export const formatDateShort = (dateString: string): string => {
  if (!dateString) return 'Fecha no disponible';
  const [year, month, day] = dateString.split('-');
  return `${day}-${month}-${year}`;
};

// Función para formatear timestamps de reviews en formato DIA/MES HORA:MINUTO
export const formatReviewTimestamp = (timestamp: string): string => {
  if (!timestamp) return 'Fecha no disponible';
  
  try {
    const date = new Date(timestamp);
    
    // Verificar que la fecha es válida
    if (isNaN(date.getTime())) {
      return 'Fecha inválida';
    }
    
    // Formatear en español: DIA/MES HORA:MINUTO
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}/${month} ${hours}:${minutes}`;
  } catch (error) {
    return 'Error de fecha';
  }
};

// Función para formatear fechas de notificaciones en formato MES/DIA HORA:MINUTO
export const formatNotificationDate = (timestamp: string): string => {
  if (!timestamp) return 'Fecha no disponible';
  
  try {
    const date = new Date(timestamp);
    
    // Verificar que la fecha es válida
    if (isNaN(date.getTime())) {
      return 'Fecha inválida';
    }
    
    // Tiempo relativo en español (espeja formatRelativeTime de mobile)
    const diffMs = Date.now() - date.getTime();
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMs < 0 || diffMins < 1) return 'Ahora';
    if (diffMins < 60) return `Hace ${diffMins} min`;
    if (diffHours < 24) return `Hace ${diffHours}h`;
    if (diffDays === 1) return 'Ayer';
    if (diffDays < 7) return `Hace ${diffDays}d`;
    if (diffDays < 30) return `Hace ${Math.floor(diffDays / 7)} sem`;

    // Fallback absoluto para fechas viejas: MES/DIA HORA:MINUTO
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${month}/${day} ${hours}:${minutes}`;
  } catch (error) {
    return 'Error de fecha';
  }
}; 